
define("rv!templates/about/home",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"correctCPHTop" },
      f:[ { t:7,
          e:"div",
          a:{ id:"home-mainslideshow" } },
        " ",
        { t:7,
          e:"div",
          a:{ id:"middleContent" },
          f:[ { t:7,
              e:"img",
              a:{ "class":"home_hrtopIMG",
                src:"https://adestinn2blob.blob.core.windows.net/images/hrtop.gif",
                alt:"" } },
            " ",
            { t:7,
              e:"div",
              a:{ id:"tblMiddle" },
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"mainpageMiddle" },
                  f:[ { t:7,
                      e:"img",
                      a:{ "class":"homeMiddleIMG",
                        src:[ "https://adestinn2blob.blob.core.windows.net/images/home/",
                          { t:2,
                            x:{ r:[ "user" ],
                              s:"_0!=null?\"kids_20160112\":\"istock_000034426020_271x107croped_20160114\"" } },
                          ".jpg" ],
                        alt:"" } },
                    " ",
                    { t:7,
                      e:"h4",
                      a:{ style:"margin-top: 20px" },
                      f:[ "Adestinn Introduces PerfectSaver ",
                        { t:7,
                          e:"sup",
                          f:[ "®" ] } ] },
                    " ",
                    { t:7,
                      e:"p",
                      a:{ style:"text-align: center; font-weight: bold" },
                      f:[ "Taking the guesswork out of saving" ] },
                    " ",
                    { t:7,
                      e:"div",
                      f:[ { t:4,
                          f:[ "Adestinn's up to 50% match" ],
                          n:50,
                          x:{ r:[ "Settings.MatchPercentage" ],
                            s:"_0===\"Default\"" } },
                        { t:4,
                          n:51,
                          f:[ "Adestinn's ",
                            { t:2,
                              r:"Settings.MatchPercentage" },
                            " match" ],
                          x:{ r:[ "Settings.MatchPercentage" ],
                            s:"_0===\"Default\"" } },
                        " is easy to understand but not always easy to calculate. That is why Adestinn implemented PerfectSaver. ",
                        { t:7,
                          e:"br" },
                        { t:7,
                          e:"br" },
                        " PerfectSaver calculates how much a vacation is going to cost and, if needed, how much your scheduled savings will need to be increased to pay for it. You simply select your hotel, dates and number of travelers and let PerfectSaver adjust your savings schedule to make it happen. ",
                        { t:7,
                          e:"br" },
                        { t:7,
                          e:"br" },
                        { t:7,
                          e:"a",
                          a:{ href:"/#/perfect-saver",
                            style:"color: #08c" },
                          f:[ "Learn More About PerfectSaver" ] },
                        "." ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"mainpageMiddle" },
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"margin: 0px auto" },
                      f:[ { t:7,
                          e:"img",
                          a:{ alt:"adestinn",
                            "class":"homeMiddleIMG",
                            src:[ "https://adestinn2blob.blob.core.windows.net/images/home/",
                              { t:2,
                                x:{ r:[ "user" ],
                                  s:"_0!=null?\"surf_20160112\":\"shutterstock_88903453_20160114\"" } },
                              ".jpg" ] } } ] },
                    " ",
                    { t:7,
                      e:"h4",
                      a:{ style:"margin-top: 20px",
                        runat:"server",
                        id:"customerPerkText" },
                      f:[ "Members Love It" ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ runat:"server",
                        id:"customerText",
                        style:"overflow-y: auto" },
                      f:[ "\"I love that Starbucks is offering this service. My fiancé and I are using Adestinn to save for our honeymoon.\" ",
                        { t:7,
                          e:"div",
                          a:{ "class":"testimonal" },
                          f:[ "- Karen P., Starbucks" ] },
                        " \"Love Adestinn!! with the savings program and the 50% match I have been staying in Luxury rooms and saving for travels to New York City and other exciting destinations\" ",
                        { t:7,
                          e:"div",
                          a:{ "class":"testimonal" },
                          f:[ "- Theresa Z., BlueCross/BlueShield of MN" ] },
                        " \"Adestinn is exponentially better than a standard savings account—it's amazing how fast it adds up.\" ",
                        { t:7,
                          e:"div",
                          a:{ "class":"testimonal" },
                          f:[ "- Chad B., Abbott Labs" ] },
                        " \"My favorite thing about using Adestinn was knowing before we started our trip that the hotel was paid for and I did not need to worry about anything.\" ",
                        { t:7,
                          e:"div",
                          a:{ "class":"testimonal" },
                          f:[ "- Holly B., BlueCross/BlueShield of MN" ] },
                        " \"It’s a different way to think about booking hotels and planning trips, but once you understand the basic concept, the benefits are worth it. The hotel was great, I look forward to avoiding a lot of the guesswork and hotel shopping in our future vacations. I highly recommend the program.\" ",
                        { t:7,
                          e:"div",
                          a:{ "class":"testimonial" },
                          f:[ "- Landon T., FOA" ] } ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"mainpageMiddle" },
                  f:[ { t:7,
                      e:"div",
                      a:{ id:"SpaceThree",
                        style:"overflow-y: auto; height: 500px" },
                      f:[ { t:7,
                          e:"div",
                          a:{ id:"HomeNews",
                            style:"\r\n              padding: 5px;\r\n              background-color: lightblue;\r\n              display: none;\r\n              margin-bottom: 10px;\r\n            " } },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ href:"/#/destinations/" },
                          f:[ { t:7,
                              e:"img",
                              a:{ "class":"homeMiddleIMG",
                                src:[ "https://adestinn2blob.blob.core.windows.net/images/home/",
                                  { t:2,
                                    x:{ r:[ "user" ],
                                      s:"_0!=null?\"group_20160112\":\"womanhat_20160114\"" } },
                                  ".jpg?v=2" ],
                                alt:"" } } ] },
                        " ",
                        { t:7,
                          e:"h4",
                          a:{ style:"margin-top: 20px" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/destinations/" },
                              f:[ "100+ Destinations" ] } ] },
                        " ",
                        { t:7,
                          e:"div",
                          f:[ "Create your saving plan then use your scheduled savings to book now at any of our handpicked, top-branded, and boutique hotels and resorts. " ] } ] } ] } ] },
            " ",
            { t:7,
              e:"img",
              a:{ "class":"home_hrtopIMG",
                src:"https://adestinn2blob.blob.core.windows.net/images/hrtop.gif",
                alt:"" } },
            " ",
            { t:7,
              e:"br",
              a:{ "class":"clear" } },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack correctCPHTopInternal" },
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/about/" },
                      f:[ "It's easy." ] } ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ { t:4,
                      f:[ "Get up to a 50%" ],
                      n:50,
                      x:{ r:[ "Settings.MatchPercentage" ],
                        s:"_0===\"Default\"" } },
                    { t:4,
                      n:51,
                      f:[ "Get a ",
                        { t:2,
                          r:"Settings.MatchPercentage" } ],
                      x:{ r:[ "Settings.MatchPercentage" ],
                        s:"_0===\"Default\"" } },
                    " match on your vacation savings simply by setting up automatic contributions to your FDIC Adestinn Vacation Savings Account. ",
                    { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:"/#/about/" },
                      f:[ "More >" ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack" },
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/Security" },
                      f:[ "It's secure." ] } ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ "Your funds are saved in an FDIC insured account at US Bank, and you can use them to book our hotel rooms or get it out at any time. ",
                    { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:"/#/Security" },
                      f:[ "More >" ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack" },
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/Empowered" },
                      f:[ "It's empowering." ] } ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ "Vacations result in reduced stress and increased wellness and job satisfaction.",
                    { t:7,
                      e:"br" },
                    " ",
                    { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:"/#/Empowered" },
                      f:[ "More >" ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack correctCPHTopInternal",
                style:"text-align: center" },
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/faq" },
                      f:[ "Questions?" ] } ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ "Contact Member Support ",
                    { t:2,
                      r:"Phones.MemberSupportPhone" },
                    " ",
                    { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:"/#/contact/?subject=Question" },
                      f:[ { t:2,
                          r:"Emails.MemberSupport" } ] },
                    " ",
                    { t:7,
                      e:"br" },
                    " ",
                    { t:7,
                      e:"center",
                      f:[ { t:7,
                          e:"strong",
                          f:[ "OR" ] } ] },
                    " Sales ",
                    { t:2,
                      r:"Phones.SalesDesk800" },
                    " ",
                    { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:[ "/#/contact/?to=",
                          { t:2,
                            r:"Emails.SalesEmail" },
                          "&subject=Question" ] },
                      f:[ { t:2,
                          r:"Emails.SalesEmail" } ] } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack",
                style:"text-align: center" },
              f:[ { t:7,
                  e:"h4",
                  f:[ "Member Support Hours" ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ { t:3,
                      x:{ r:[ "Settings.MemberSupportHours" ],
                        s:"_0.replace(/-br-/g,\"<br />\")" } } ] } ] },
            " ",
            { t:7,
              e:"div",
              a:{ "class":"span4 well noBack",
                style:"text-align: center" },
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ style:"color: #08c",
                        href:"/#/faq" },
                      f:[ "Frequently Asked Questions" ] } ] },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/#/hr/?tr=homebody" },
                      f:[ "Information For Employers" ] } ] } ] } ] } ] },
    " ",
    { t:7,
      e:"script",
      a:{ type:"text/javascript" },
      f:[ "  function popNews(newsData) {\r\n    var newsTemplate = \"<h3>{0}</h3>{1}<br /><br />\",\r\n      rows = [],\r\n      newsbody = $(\"#HomeNews\");\r\n\r\n    var news = [];\r\n    try {\r\n      news = JSON.parse(newsData);\r\n    } catch (err) {\r\n      alert(\"error - \" + err.toString());\r\n      //alert(errormsg.show().html(newsData));\r\n      //errormsg.show().html(newsData);\r\n    }\r\n    if (news.length > 0) {\r\n      for (var i = 0; i < news.length; i++) {\r\n        var newsItem = news[i];\r\n        rows.push(newsTemplate.format(newsItem.Headline, newsItem.Body));\r\n      }\r\n      newsbody.html(\r\n        '<h1 style=\"text-align: center\">UPDATE</h1>' + rows.join(\"\"),\r\n      );\r\n      newsbody.show();\r\n    } else {\r\n      newsbody.hide();\r\n    }\r\n  }\r\n\r\n  $.ajax({\r\n    type: \"POST\",\r\n    url: \"/newsAJAX.aspx\",\r\n    success: function (news) {\r\n      popNews(news);\r\n    },\r\n    error: function () {\r\n      errormsg\r\n        .show()\r\n        .html(\r\n          \"Something went wrong. Please re-load the page and try again or contact Adestinn Support.\",\r\n        );\r\n    },\r\n  });" ] } ] };});
